import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listUsers:[],
  newUser:[],
  listRelatoresPonencia:[],
  listJueces:[],
  listMagistrados:[],
};
export const mutations = {
  GET_USERS({ context }, users) {
    let users_array = [];
    Object.entries(users).forEach(([key, val]) => users_array.push(val));
    return (state.listUsers = users_array);
  },

  SAVE_USERS({ context }, user) {
    state.newUser = Object.assign({}, user);
  },
  EDIT_USER({ context }, dataUser) {
    state.dataUser = Object.assign({}, dataUser);
  },
  GET_RELATORES({ context }, users) {
    let users_array = [];
    Object.entries(users).forEach(([key, val]) => users_array.push(val));
    return (state.listRelatoresPonencia = users_array);
  },

  GET_JUECES({ context }, jueces) {
    let jueces_array = [];
    Object.entries(jueces).forEach(([key, val]) => jueces_array.push(val));
    return (state.listJueces= jueces_array);
  },
  GET_MAGISTRADOS({ context }, magistrados) {
    let magistrados_array = [];
    Object.entries(magistrados).forEach(([key, val]) => magistrados_array.push(val));
    return (state.listMagistrados= magistrados_array);
  },
};
export const actions = {
  GET_USERS({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_USERS", response.data.data.users);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_ESTADISTICA_ABOGADOS({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          resolve(response.data.data);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SAVE_USERS({ commit }, user) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(user)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("SAVE_USERS", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  EDIT_USER({ commit }, dataUser) { //axios, mandar parametros para post
    //console.log("store",role);
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.put(dataUser)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("EDIT_USER", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  DELETE_USER({ commit }, id) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.delete(id)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          // commit("DELETE_USER", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GET_RELATORES_PONENCIA({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_RELATORES", response.data.data.relatores);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GET_JUECES({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_JUECES", response.data.data.jueces);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  RESET_PASSWORD({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(data)
        .then(response => {
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_MAGISTRADOS({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_MAGISTRADOS", response.data.data.magistrados);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  IMPERSONATE_START({ commit }, user) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(user)
        .then(response => {
          commit("SET_LOADING", false);
          commit("SAVE_USERS", response);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  IMPERSONATE_STOP({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_USERS", response);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
};

export const getters = {
  listUsers: state => state.listUsers,
  newUser: state => state.newUser,
  listRelatoresPonencia: state => state.listRelatoresPonencia,
  listJueces: state => state.listJueces,
  listMagistrados: state => state.listMagistrados
};
